// extracted by mini-css-extract-plugin
export default {"main":"Footer_main__ETO+F","logo":"Footer_logo__+JiYo","links":"Footer_links__wMgLO","connect":"Footer_connect__FcqjI"};